import React from "react";

import { useAppSelector } from "../../../app/hooks";

import {
  isCreditAccountStakeholdersRevampEnabled,
} from "../../configs/logic/Slice";
import LegacyEmployeeCard from "./LegacyEmployeeCard";
import EmployeeCard from "./EmployeeCard";


const EmployeeCardContainer: React.FC = () => {
  const isRevampEnabled = useAppSelector(
    isCreditAccountStakeholdersRevampEnabled
  );

  return isRevampEnabled ? <EmployeeCard /> : <LegacyEmployeeCard />;
};

export default EmployeeCardContainer;